import Vue from 'vue'
import VueCookies from 'vue-cookies'

const state = {
    musicData: {}, // 音乐数据，按模块存储
    // 音乐播放器状态
    player: {
        currentSong: null, // 当前播放的歌曲
        isPlaying: false, // 是否正在播放
        currentTime: 0, // 当前播放时间（秒）
        duration: 0, // 歌曲总时长（秒）
        volume: 1, // 音量 0-1
        isMuted: false, // 是否静音
        playMode: 'sequence', // 播放模式: sequence|loop|single|random
        playlist: [], // 当前播放列表
        currentIndex: -1, // 当前播放索引
        isLoading: false // 是否正在加载
    }
}

const getters = {
    // 获取指定模块的音乐列表
    getMusicList: (state) => (module) => {
        return state.musicData[module] || []
    },
    // 获取指定模块收藏的音乐列表
    getFavoriteMusicList: (state) => (module) => {
        const list = state.musicData[module] || []
        return list.filter(item => item.collectId)
    },

    // ========== 播放器相关 getters ==========
    // 获取播放器状态
    getPlayerState: (state) => {
        return state.player
    },
    // 获取当前播放的歌曲
    getCurrentSong: (state) => {
        return state.player.currentSong
    },
    // 获取播放状态
    getIsPlaying: (state) => {
        return state.player.isPlaying
    },
    // 获取当前播放时间
    getCurrentTime: (state) => {
        return state.player.currentTime
    },
    // 获取歌曲总时长
    getDuration: (state) => {
        return state.player.duration
    },
    // 获取播放列表
    getPlaylist: (state) => {
        return state.player.playlist
    },
    // 获取当前播放索引
    getCurrentIndex: (state) => {
        return state.player.currentIndex
    },
    // 是否有上一首
    getHasPrevious: (state) => {
        return state.player.currentIndex > 0
    },
    // 是否有下一首
    getHasNext: (state) => {
        return state.player.currentIndex < state.player.playlist.length - 1
    }
}

const mutations = {
    // ========== 音乐数据管理 ==========
    // 添加音乐项
    addMusicItem(state, { module, item }) {
        if (!state.musicData) {
            Vue.set(state, 'musicData', {})
        }
        if (!state.musicData[module]) {
            Vue.set(state.musicData, module, [])
        }
        state.musicData[module].unshift(item)
    },
    // 更新音乐项
    updateMusicItem(state, { module, id, data }) {
        if (state.musicData && state.musicData[module]) {
            const index = state.musicData[module].findIndex(item => item.id === id)
            if (index !== -1) {
                Vue.set(state.musicData[module], index, { ...state.musicData[module][index], ...data })
            }
        }
    },
    // 删除音乐项
    deleteMusicItem(state, { module, id }) {
        if (state.musicData && state.musicData[module]) {
            const index = state.musicData[module].findIndex(item => item.id === id)
            if (index !== -1) {
                state.musicData[module].splice(index, 1)
            }
        }
    },
    // 设置音乐数据
    setMusicData(state, { module, data }) {
        if (!state.musicData) {
            Vue.set(state, 'musicData', {})
        }
        Vue.set(state.musicData, module, data)
    },

    // ========== 音乐播放器状态管理 ==========
    // 设置当前播放的歌曲
    setCurrentSong(state, song) {
        state.player.currentSong = song
    },
    // 设置播放状态
    setPlayingState(state, isPlaying) {
        state.player.isPlaying = isPlaying
    },
    // 设置播放时间
    setCurrentTime(state, time) {
        state.player.currentTime = time
    },
    // 设置歌曲总时长
    setDuration(state, duration) {
        state.player.duration = duration
    },
    // 设置音量
    setVolume(state, volume) {
        state.player.volume = volume
    },
    // 设置静音状态
    setMuted(state, isMuted) {
        state.player.isMuted = isMuted
    },
    // 设置播放模式
    setPlayMode(state, mode) {
        state.player.playMode = mode
    },
    // 设置播放列表
    setPlaylist(state, playlist) {
        state.player.playlist = playlist
    },
    // 设置当前播放索引
    setCurrentIndex(state, index) {
        state.player.currentIndex = index
    },
    // 设置加载状态
    setLoading(state, isLoading) {
        state.player.isLoading = isLoading
    }
}

const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
